import React, {
	createContext,
	useContext,
	useState,
	ReactNode,
	useEffect,
} from "react";


// Define the context state interface
interface SearchContextState {
    searchCount: number;
    setSearchCount: (count: number) => void;
}

// Create the context with default values
const SearchCountContext = createContext<SearchContextState | undefined>(undefined);

// Provider props interface
const getInitialState = ()=>{
    return Number(localStorage.getItem("searchCount")) || 0;
}   
// Search provider component
export const SearchCountProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {

	const [searchCount, setSearchCount] = useState<number>(getInitialState);

	useEffect(()=>{
		localStorage.setItem("searchCount", searchCount.toString());
	}, [searchCount]);
	
	return (
		<SearchCountContext.Provider value={{ searchCount, setSearchCount }}>
			{children}
		</SearchCountContext.Provider>
	);
};

// Custom hook to use the search context
export const useSearchCount = (): SearchContextState => {
	const context = useContext(SearchCountContext);

	if (context === undefined) {
		throw new Error("useSearchCount must be used within a SearchProvider");
	}

	return context;
};
